import { UpdateSavedSearchProps } from "../types";
import { getHeaders } from "../utils/getHeaders";

const updateSavedSearches = async (
  url: string,
  params: UpdateSavedSearchProps,
  authToken: string,
  isToUseAuthZero: boolean
): Promise<boolean> => {
  const headers = getHeaders(authToken, isToUseAuthZero);

  const res = await fetch(url, {
    method: "PUT",
    headers,
    body: JSON.stringify(params),
  });

  if (!res.ok) {
    throw new Error(
      `An error (${res.status}) occurred while updating the data.`
    );
  }

  return true;
};

export default updateSavedSearches;
